export enum IncentivationSourceType {
    ManualActionIncentivationSource = "ManualActionIncentivationSource",
}

export interface BaseIncentivationSourceModel {
    type: IncentivationSourceType
};


export interface ManualActionIncentivationSourceModel extends BaseIncentivationSourceModel {
    canBulkUploadIncentivationData: boolean;
    canBeCompletedByEmployeeUser: boolean;
};
